import ApiContext from 'api/ApiContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';
import { getInternalUrl } from 'utils/routing';

const useBacklinkUrl = (parentId: string, parentFrontendId?: string) => {
  const { getPollDays } = useContext(ApiContext);
  const query = useQuery(['polling_days'], getPollDays, {
    refetchInterval: false,
    cacheTime: Infinity,
    staleTime: Infinity,
  });

  const currentPollId = query.data?.data?.[0]?.id;

  if (!currentPollId) return null;

  if (parentId === currentPollId) {
    return '/';
  }

  const url = parentId
    ? getInternalUrl({ id: parentId, frontend_id: parentFrontendId }, 'poll_day')
    : '/archiv';

  return url;
};

export default useBacklinkUrl;
